
/* SUPPORT */
export const GET_SUPPORT_CREATE = "GET_SUPPORT_CREATE";
export const GET_SUPPORT_CREATE_SUCCESS = "GET_SUPPORT_CREATE_SUCCESS";
export const GET_SUPPORT_CREATE_FAIL = "GET_SUPPORT_CREATE_FAIL";

export const RESET_SUPPORT_STATE = 'RESET_SUPPORT_STATE';
export const RESET_SUPPORT_ACTION_STATE = 'RESET_SUPPORT_ACTION_STATE';